export default {
  setUser(state, payload) {
    state.userData = payload
  }
}